// axiosInstance.js
import axios from "axios";
import Cookies from "js-cookie";

// Create the axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Default API URL
  headers: {
    "Content-Type": "application/json", // Default content type
  },
});

// Add a request interceptor to automatically attach the token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = Cookies.get("token"); // Or wherever you store your token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
